import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TiltCard from './TiltCard';
import './ProductCard.css';

const ProductCard = ({ to, image, title, subtitle, description, features, colors, cta = 'View Details' }) => (
  <TiltCard as={Link} to={to} className="product-card">
    <div className="product-card-image">
      <img src={image} alt={title} />
    </div>
    <div className="product-card-body">
      {colors && colors.length > 0 && (
        <div className="product-card-colors">
          {colors.map((color, i) => (
            <span key={i} className="color-dot" style={{ backgroundColor: color }} />
          ))}
        </div>
      )}
      <h3 className="product-card-title">{title}</h3>
      {subtitle && <p className="product-card-subtitle">{subtitle}</p>}
      {description && <p className="product-card-description">{description}</p>}
      {features && features.length > 0 && (
        <ul className="product-card-features">
          {features.map((feature, i) => (
            <li key={i}>
              <CheckCircleOutlineIcon />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      )}
      <span className="product-card-cta">
        {cta} <ArrowForwardIcon />
      </span>
    </div>
  </TiltCard>
);

export default ProductCard;
